import type { MaybeComputedElementRef } from "@vueuse/core";
import type { MaybeRefOrGetter } from "vue";
import { useElementAutoFocus, useElementAutoSelect } from "ls/composables/useElementAutos";

export function useTextFieldAutos(ref: MaybeComputedElementRef<HTMLInputElement>, options: { autofocus?: MaybeRefOrGetter<boolean>; autoselect?: MaybeRefOrGetter<boolean> } = {}) {
  useElementAutoFocus(ref, { enabled: options.autofocus });
  useElementAutoSelect(ref, { enabled: options.autoselect });
}
